export const processAvatarToWebP = (
  file: File,
  maxSize = 256
): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (event) => {
      const img = new Image()

      img.onload = () => {
        const canvas = document.createElement('canvas')

        // Calculate dimensions to maintain aspect ratio, but cap at maxSize
        let width = img.width
        let height = img.height
        if (width > height) {
          if (width > maxSize) {
            height = Math.round((height * maxSize) / width)
            width = maxSize
          }
        } else {
          if (height > maxSize) {
            width = Math.round((width * maxSize) / height)
            height = maxSize
          }
        }

        canvas.width = width
        canvas.height = height

        const ctx = canvas.getContext('2d')
        if (!ctx) return reject(new Error('Canvas not supported'))

        ctx.drawImage(img, 0, 0, width, height)

        // Convert to WebP at 80% quality
        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error('Blob conversion failed'))

            // Re-package as a File object so your existing logic accepts it
            const webpFile = new File([blob], 'avatar.webp', {
              type: 'image/webp',
            })
            resolve(webpFile)
          },
          'image/webp',
          0.8
        )
      }
      img.onerror = () => reject(new Error('Failed to load image'))
      img.src = event.target?.result as string
    }

    reader.onerror = () => reject(new Error('Failed to read file'))
    reader.readAsDataURL(file)
  })
}
